import Scrollbar from './scrollbarWidth';

(function scrollLock() {
    this.position = 0;
    window.isScrollLocked = false;
    let main = document.querySelector('main');
    let body = document.body;
    let fixedItems = [];

    if (!main) return;

    document.documentElement.style.setProperty('--scroll-y', `0`);

    window.addEventListener('scroll', () => {
        if (window.isScrollLocked) return;
        document.documentElement.style.setProperty('--scroll-y', `-${this.position}px`);
    });

    window.addEventListener('screenScrollLock', () => {
        let scrollbarWidth = Scrollbar.getScrollbarWidth();
        let defaultMainPaddingRight = getDefaultPaddingRight(main);
        fixedItems = document.querySelectorAll('.scrollbar-fix');

        window.isScrollLocked = true;
        this.position = window.scrollY;
        body.classList.add('body--is-locked');
        main.style.transform = `translate(0, -${this.position}px)`;
        main.style.paddingRight = `${defaultMainPaddingRight + scrollbarWidth}px`;

        Array.from(fixedItems).forEach((item) => {
            item.style.paddingRight = `${getDefaultPaddingRight(item) + scrollbarWidth}px`;
        });
    });

    window.addEventListener('screenScrollUnlock', () => {
        if (!window.isScrollLocked) return;

        body.classList.remove('body--is-locked');
        main.style.transform = null;
        window.scrollTo(0, parseInt(this.position) || 0);
        window.isScrollLocked = false;
        main.style.paddingRight = null;

        Array.from(fixedItems).forEach((item) => {
            item.style.paddingRight = null;
        });
    });

    let getDefaultPaddingRight = (element) => parseInt(window.getComputedStyle(element).paddingRight);
})();
